import fm from 'front-matter';

const modules = import.meta.glob('/src/content/projects/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
});

const projects = Object.entries(modules).map(([filepath, raw]) => {
  const { attributes, body } = fm(raw);
  return { ...attributes, body };
});

export function getAllProjects() {
  return projects;
}

export function getFeaturedProjects() {
  return projects.filter((p) => p.featured);
}

export function getProjectBySlug(slug) {
  return projects.find((p) => p.slug === slug) || null;
}

export function getProjectByTag(tag) {
  return projects.find((p) => p.tag === tag) || null;
}

export default projects;
